export const theme = {
  headerLineHeight: 'initial',
};
